import service from '@/utils/request'

export function getSystemConfig(param) {
	return service.request({
		method: 'post',
		url: '/app/system/getSystemConfig',
		data: param
	})
}

export function switchEdit(param) {
	return service.request({
		method: 'post',
		url: '/app/system/edit',
		data: param
	})
}

